<template>
  <div class="box_style_4">
    <img class="notfound-logo" src="/img/travel.png" />
    <h4 class="mt20">
      متاسفیم، برای جستجوی شما پروازی 
      <span>یافت نشد.</span>
    </h4>
    <div v-if="withoutChangeDate == true" class="btn btn-change-search" >
      <button @click="onAction(2)" type="button" class="col-6 btn btn-secondary">تغییر جستجو</button>
    </div>
    <div v-if="withoutChangeDate == false" class="btn-grp btn-group" role="group">
      <button @click="onAction(1)" type="button" class="col-4 btn btn-primary">روز قبل</button>
      <button @click="onAction(2)" type="button" class="col-6 btn btn-secondary">تغییر جستجو</button>
      <button @click="onAction(3)" type="button" class="col-4 btn btn-primary">روز بعد</button>
    </div>
    <small style="display: block;">جهت اطلاعات بیشتر می توانید به با شماره <span style="display: inline-block;">021-44631360-5 </span> تماس حاصل نمایید.</small>
  </div>
</template>

<script>
export default {
  name: "pdk-Flight-NotFound",
  props: { itienary: Object,
     withoutChangeDate: { type: Boolean, default: false },
  },
  data() {
    return {};
  },
  methods: {
      onAction(typeCode) {
      let type = "unknown";
      switch (typeCode) {
       
        case 1:
          type = "oneDayBefore";
          break;

        case 2:
          type = "changeSearch";
          break;

        case 3:
          type = "oneDayLater";
          break;

        default:
          type = "changeSearch";
          break;
      }

      this.$emit("notFoundAction", type);
    }
  }
};
</script>

<style>
.notfound-logo {
  width: 120px;
}
.mt20 {
  margin-top: 20px;
}
.btn-grp {
     width: 294px;
  margin-top: 20px;
}
button {
     font-size: 14px !important;
}
.btn-change-search {
      width: 240px;
}
</style>


